export default function SelectVendorResourcesDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  loaderService,
  ssDialogService,
  editVendorDialog,
  vmSharedModelService,
  bcpSharedModelService
) {
  const vm = this;

  vm.handleClose = _handleClose;
  vm.handleAdd = _handleAdd;
  vm.handleSave = _handleSave;

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function _handleClose() {
    _closeDialog();
  }

  function _handleAdd($event) {
    return _showEditVendorDialog($event, {
      vendor: vmSharedModelService.createNewVendor(vm.assessmentId),
    });
  }

  function _handleSave() {
    const selectedVendorIds = [];
    vm.vendors.forEach((vendor) => {
      if (vendor.isSelected) {
        selectedVendorIds.push(vendor.vendorId);
      }
    });

    loaderService.showViewLoader = true;
    return bcpSharedModelService.saveVendorResourcesList(vm.assessmentId, selectedVendorIds)
      .then((vendorResources) => {
        loaderService.showViewLoader = false;
        $rootScope.$broadcast('loadVendorResources', vendorResources);
        alerts.success('The Vendor Resources have been saved successfully.');
        _closeDialog();
      })
      .catch(() => {
        loaderService.showViewLoader = false;
        alerts.error('An error occurred while saving the Vendor Resources.');
      });
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    $scope.$on('vendorAdded', _handleAddedVendor);
    $scope.$on('vendorDeleted', _handleDeletedVendor);
    _selectVendorResources(vm.vendorResources);
  }

  function _selectVendorResources() {
    vm.vendorResources.forEach((vendorResource) => {
      vm.vendors.find((vendor) => {
        if (vendor.vendorId === vendorResource.vendorId) {
          vendor.isSelected = true;
          return true;
        }
        return false;
      });
      return true;
    });
  }

  function _handleAddedVendor(event, vendor) {
    vendor.isSelected = true;
    vm.vendors = vm.vendors || [];
    vm.vendors.push(vendor);
    if (vm.vendors.length > 1) {
      vm.vendors = bcpSharedModelService.sortByName(vm.vendors);
    }
  }

  function _handleDeletedVendor(event, vendorId) {
    if (!vendorId) return;
    const pos = vm.vendors.findIndex(item => item.vendorId === vendorId);
    if (pos === -1) return; // Can't find the item
    vm.vendors.splice(pos, 1);
  }

  function _showEditVendorDialog($event, locals) {
    ssDialogService.dialogs.bcp.editVendorDialog = ssDialogService.alert(
      editVendorDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.editVendorDialog);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.selectVendorResourcesDialog);
  }
}

SelectVendorResourcesDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'loaderService',
  'ssDialogService',
  'bcp.editVendorDialog',
  'vmSharedModelService',
  'bcpSharedModelService',
];
